import React from 'react'

import { IEnterpriseBottomBarProps } from './Interfaces'
import { Button, Link } from '@material-ui/core'
import useEnterpriseBottomBar from './Styles'
import { ConfirmAction } from 'smart-components'

const EnterpriseBottomBar: React.FC<IEnterpriseBottomBarProps> = ({
  lastAutoSave,
  onSaveDraftClick,
  onSubmit,
  isSavingDraft,
  isSubmitting
}) => {
  const classes = useEnterpriseBottomBar({})
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <p id="description-enterprise-paragraph" className={classes.textContainer}>
          You can only create once all questions categories are complete <br />
          Last auto-save {lastAutoSave} minute(s) ago. &nbsp;
          <Link
            classes={{
              root: classes.saveNowButtonRoot
            }}
            disabled={isSavingDraft}
            component="button"
            id="save-now-enterprise-link"
            onClick={onSaveDraftClick}
          >
            Save now
          </Link>
        </p>
        <ConfirmAction
          content="Are you ready to submit your Pointr profile and your answers to the initiative questions?"
          title="Confirm Submission"
          onConfirm={onSubmit}
          id="confirm-submission"
        >
          {(isOpen: boolean, toggleDialog: () => void) => {
            return (
              <Button
                id="enterprise-submit-button"
                variant="contained"
                onClick={toggleDialog}
                disabled={isSubmitting || isSavingDraft || isOpen}
              >
                Submit
              </Button>
            )
          }}
        </ConfirmAction>
      </div>
    </div>
  )
}

EnterpriseBottomBar.defaultProps = {
  isSavingDraft: false,
  isSubmitting: false
}

export default EnterpriseBottomBar
